type substringSearchMatch = {
  value: string;
  index: number;
};

export function substringSearch(
  haystack: Array<string>,
  elem: string,
): Array<substringSearchMatch> {
  const pin = elem.toLocaleLowerCase().trim();

  return haystack.reduce(
    (acc: Array<substringSearchMatch>, t: string, idx: number) => {
      if (t.toLowerCase().trim().includes(pin)) {
        return [...acc, { value: t, index: idx }];
      }
      return acc;
    },
    [] as Array<substringSearchMatch>,
  );
}

export function isValidUrl(url: string) {
  try {
    new URL(url);
  } catch (e) {
    return false;
  }
  return true;
}

export const highlightBoldText = (text: string) => {
  const boldRegex = /\*\*(.*?)\*\*/g;
  const highlightedText = text.replace(boldRegex, '<strong>$1</strong>');
  const headingRegex = /^(###.*)$/gm; // Updated regex pattern
  const formattedText = highlightedText.replace(
    headingRegex,
    '<span class="text-2xl">$1</span>',
  );
  const formattedText1 = formattedText.replace(/###/g, ''); // Replace with empty string
  return formattedText1;
};

export const extractInnerTextFromHTML = (htmlString: string) => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = htmlString;
  return tempElement.innerText;
};

export const camelCaseToCapitalized = (str: string) => {
  let words: any = str.replace(/([A-Z])/g, ' $1');
  words = words
    .split(' ')
    .map(
      (word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    );
  return words.join(' ');
};

export const getFilenameFromUrl = (url: unknown) => {
  // Caller passes `value?.url` where value may be an arbitrary cell
  // payload (string URL, nested object, null, undefined). Only strings
  // have `.split`; anything else returns '' so the surrounding render
  // path takes its "no filename" branch instead of crashing.
  if (!url || typeof url !== 'string') return '';

  const urlParts = url.split('/');
  const filename = urlParts[urlParts.length - 1].split('?')[0] || '';
  return filename;
};

export const copyToClipboard = (str: string) => {
  if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(str);
  } else {
    return Promise.reject('The Clipboard API is not available.');
  }
};

export const cleanHighlightedString = (inputString: string) => {
  return inputString.replace(/[#*]/g, '');
};
